import type { Feature, Polygon } from 'geojson';
import { GeoDataUtilities } from '@rogoag/shared-ts';
import { MultiPolygonCoords } from '../../types/types';

class PolysMerger {
  merge(
    firstPoly: Feature<Polygon>,
    secondPoly: Feature<Polygon>,
  ): { multiPolygonCoords: MultiPolygonCoords; error?: string } {
    if (!GeoDataUtilities.polygonOverlapsPolygon(firstPoly, secondPoly).overlaps) {
      return { multiPolygonCoords: [], error: 'Polygons do not intersect, aborting.' };
    }

    const gluedShape = GeoDataUtilities.glueShapes([firstPoly, secondPoly]);
    const { isValid: isShapeValid } = GeoDataUtilities.isPolygonValid(gluedShape);

    if (!isShapeValid) {
      return { multiPolygonCoords: [], error: `Merged polygon is not valid, aborting.` };
    }

    if (gluedShape.geometry.type === 'MultiPolygon') {
      return { multiPolygonCoords: gluedShape.geometry.coordinates };
    }

    if (gluedShape.geometry.type === 'Polygon') {
      return { multiPolygonCoords: [gluedShape.geometry.coordinates] };
    }

    return { multiPolygonCoords: [], error: `Merged polygon has unexpected geometry type: aborting.` };
  }
}

const polysMerger = new PolysMerger();

export default polysMerger;
